module.exports = __webpack_public_path__ + "img/ki.645af307.svg";